export default "__VITE_ASSET__lZbdiTvk__"